import { useGlobalStore } from "@/stores/globalStore";
import { useOrderFormStore } from "@/stores/forms/orderFormStore";

export default () => {
  const disableCountryByActiveCoin = (countries) => {
    const store = useOrderFormStore();

    return countries.map((country) => {
      if (store.getRestrictedCountriesByActiveCoin.includes(country.code)) {
        return {
          isDisabled: true,
          ...country,
        };
      }
      return country;
    });
  };
  const fetchCountries = async () => {
    const store = useGlobalStore();

    const { countries } = store.global;
    if (countries.length <= 0) {
      await store.fetchCountries();
    }

    const formattedCountries = disableCountryByActiveCoin(
      store.global.countries
    );

    return formattedCountries;
  };
  return {
    fetchCountries,
  };
};
